// src/push.js — registrasi Web Push dari browser/HP
import api from "./axiosConfig";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  return typeof Notification !== "undefined" ? Notification.permission : "default";
}

// Aktifkan push: register SW -> minta izin -> subscribe -> simpan ke server.
// Harus dipanggil dari event klik (gesture) agar izin bisa muncul.
export async function enablePush(role) {
  if (!pushSupported()) {
    throw new Error("Browser/HP ini tidak mendukung notifikasi push.");
  }

  const reg = await navigator.serviceWorker.register("/push-sw.js");
  await navigator.serviceWorker.ready;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    throw new Error("Izin notifikasi ditolak.");
  }

  const { data } = await api.get("/push/vapid-public-key");
  if (!data || !data.publicKey) {
    throw new Error("Server belum mengaktifkan Web Push (VAPID key kosong).");
  }

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }

  await api.post("/push/subscribe", { subscription: sub, role });
  return true;
}
